module.exports = __webpack_public_path__ + "static/media/support.b3b439f4.png";